<div class="ml-2">
  <bpt-search
    appBlurOnSearch
    *ngIf="isSbuMasterDataLoaded && isScopeMasterDataLoaded && isUsersMasterDataLoaded"
    class="search-component"
    [placeholder]="placeHolder"
    [errorText]="errorText"
    [advancedSearch]="true"
    [searchControls]="searchControl"
    [search]="getSearchResults"
    [advancedSearchMethod]="getAdvancedSearchResults"
  >
  </bpt-search>
</div>

<div *ngIf="isPanelHubDataAvailable">
  <div class="bpt-main-content-containerForChangeControl">
    <div class="displayCenter" *ngIf="showLoader">
      <app-spinner [useOverlay]="false"></app-spinner>
    </div>

    <app-panel-hub
     #panelHub
      [config]="panelHubConfig"
      (panelHubStateChanged)="onPanelHubStateChanged($event)"
  
      [pagedData]="pagedData"
      (panelEventHub)="onPanelHubInitialized($event)"
      (viewChanged)="onPanelViewChanged($event)"
      class="change-control-panel"
    >
      <!-- Card Header Template -->
   <ng-template #headerTemplate let-data="dataVar">
        <div class="card-header header-flex">
          <div class="header-left changeControl-header font-semibold blue-color">
            <b pTooltip="{{ data.changeControlNumber }} {{ data.changeControlName }}">
              <a (click)="openChangeControl(data?.changeControlNumber)">
                <u>
                {{ data?.changeControlNumber }} {{ data?.changeControlName }}
                </u>
              </a>
            </b>
          </div>
          <div class="header-right phase-style icon-alignment ml-3">
            <b>
              <i
                class="pi pi-circle-fill"
                [ngClass]="calculatePhaseColor(data.phase)">
              </i>
            </b>
            <span class="iconAlignment ml-2">
              <b>
              {{ displayPhaseLabelWithDate(
                data?.phase,
                data.completionDate,
                data.targetCompletionDate,
                data.phaseName
              ) }}
              </b>
            </span>
          </div>

        </div>
      </ng-template>

      <!-- Card Detail Template -->
      <ng-template #contentTemplate let-data="dataVar">
        <!-- Default View -->
        <div *ngIf="panelCardViewType === defaultView" class="grid">
          <div class="col-fixed" style="width: 20%">
            <div class="font-semibold mb-1">Category</div>
            <div class="content-wrap">{{ data?.categoryName }}</div>
          </div>
          <div class="col-fixed" style="width: 20%">
            <div class="font-semibold mb-1">Priority</div>
            <div class="content-wrap">{{ data?.priorityName }}</div>
          </div>
          <div class="col-fixed" style="width: 20%">
            <div class="font-semibold mb-1">Implementation Owner(s)</div>
            <ul class="list">
              <li class="content-wrap" *ngFor="let owner of data?.implementationOwnersInformation">
                <span [ngClass]="{'inActiveGroup': owner.isActive===false || owner.isTerminated===true}">
                  {{ owner.name }}
                </span>
              </li>
            </ul>
          </div>
          <div class="col-fixed" style="width: 20%">
            <div class="font-semibold mb-1">Responsible Sub-BU</div>
            <ul>
                <li
                  class="content-wrap"
                  *ngFor="let subBU of data?.responsibleSubBU"
                >
                  {{ subBU }}
                </li>
              </ul>          
            </div>
          <div class="col-fixed" style="width: 20%">
            <div class="font-semibold mb-1">eQMS Scope(s)</div>
            <ul class="list">
              <li class="content-wrap" *ngFor="let scope of data?.eQMSScopeDisplayNames">
                {{ scope }}
              </li>
            </ul>
          </div>
        </div>

        <!-- Assignment View -->
        <div *ngIf="panelCardViewType === assignmentView" class="grid">
          <div class="col-fixed" style="width: 16%">
            <div class="font-semibold mb-1">Implementation Owner(s)</div>
            <ul class="list">
              <li class="content-wrap" *ngFor="let owner of data?.implementationOwnersInformation">
                <span [ngClass]="{'inActiveGroup': owner.isActive===false || owner.isTerminated===true}">
                  {{ owner.name }}
                </span>
              </li>
            </ul>
          </div>

          <div class="col-fixed" style="width: 16%">
            <div class="font-semibold mb-1">Collaborator(s)</div>
            <ul class="list">
              <li class="content-wrap" *ngFor="let collab of data?.collaboratorsInformation">
                <span [ngClass]="{'inActiveGroup': collab.isActive===false || collab.isTerminated===true}">
                  {{ collab.name }}
                </span>
              </li>
            </ul>
          </div>

          <div class="col-fixed" style="width: 16%">
            <div class="font-semibold mb-1">Reviewer(s)</div>
            <ul class="list">
              <li class="content-wrap" *ngFor="let reviewer of data?.reviewersInformation">
                <span [ngClass]="{'inActiveGroup': reviewer.isActive===false || reviewer.isTerminated===true}">
                  {{ reviewer.name }}
                </span>
              </li>
            </ul>
          </div>

          <div class="col-fixed" style="width: 16%">
            <div class="font-semibold mb-1">Approver(s)</div>
            <ul class="list">
              <li class="content-wrap" *ngFor="let approver of data?.approversInformation">
                <span [ngClass]="{'inActiveGroup': approver.isActive===false || approver.isTerminated===true}">
                  {{ approver.name }}
                </span>
              </li>
            </ul>
          </div>

          <div class="col-fixed" style="width: 16%">
            <div class="font-semibold mb-1">Verifier(s)</div>
            <ul class="list">
              <li class="content-wrap" *ngFor="let verifier of data?.verifiersInformation">
                <span [ngClass]="{'inActiveGroup': verifier.isActive===false || verifier.isTerminated===true}">
                  {{ verifier.name }}
                </span>
              </li>
            </ul>
          </div>

          <div class="col-fixed" style="width: 16%">
            <div class="font-semibold mb-1">Internal Client Contact</div>
            <ul class="list">
              <li class="content-wrap">
                <span [ngClass]="{'inActiveGroup': data?.internalClientContactInformation.isActive===false 
                || data?.internalClientContactInformation.isTerminated===true}">
                  {{ data?.internalClientContactInformation.name }}
                </span>
              </li>
            </ul>
          </div>
        </div>
      </ng-template>
    </app-panel-hub>

    <div class="displayCenter" *ngIf="!showLoader && (!pagedData || pagedData.data.length === 0) && !isPanelHubDataAvailable">
      <app-empty-results></app-empty-results>
    </div>
  </div>
</div>

<div class="displayCenter"
  *ngIf="(changeControlSearchResult == undefined || changeControlSearchResult.length == 0) && isSearch && !spinnerOn">
  <app-empty-results></app-empty-results>
</div>

<div class="displayCenter" *ngIf="spinnerOn">
  <app-spinner [useOverlay]="false"></app-spinner>
</div>
